<div class="number-input">
    <input
        type="number"
        [id]="id"
        #inputEl
        [disabled]="disabled"
        [required]="required"
        [readOnly]="readonly"
        [step]="step"
        [min]="min"
        [max]="max"
        (change)="onChange()"
        (input)="onChange()"
        (blur)="onBlur()"
        [placeholder]="placeholder"
    />
    <span class="controls" *ngIf="!readonly && !disabled">
        <button type="button" class="increment" (click)="increment()"></button>
        <button type="button" class="decrement" (click)="decrement()"></button>
    </span>
    <span *ngIf="symbol" class="number-input__symbol">{{ symbol }}</span>
</div>
